import {Divider, Typography} from '@mui/material'
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress'
import {styled} from '@mui/material/styles'

export const SUMMARY_DRAWER_WIDTH = 435

const PREFIX = 'SummaryComponent'

export const classes = {
  root: `${PREFIX}-root`,
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  mainFiltersContainer: `${PREFIX}-mainFiltersContainer`,
  title: `${PREFIX}-title`,
  summarySubsectionContainer: `${PREFIX}-summarySubsectionContainer`,
  selectRoot: `${PREFIX}-selectRoot`,
  loadSnapshotButtonContainer: `${PREFIX}-loadSnapshotButtonContainer`,
  loadSnapshotButton: `${PREFIX}-loadSnapshotButton`,
  checkbox: `${PREFIX}-checkbox`,
  checkboxesContainer: `${PREFIX}-checkboxesContainer`,
  closeButton: `${PREFIX}-closeButton`,
  summaryTitle: `${PREFIX}-summaryTitle`,
  summarySubtitle: `${PREFIX}-summarySubtitle`,
  summarySubtitle2: `${PREFIX}-summarySubtitle2`,
  summaryTitleColorTeal: `${PREFIX}-summaryTitleColorTeal`,
  summaryParagraph: `${PREFIX}-summaryParagraph`,
  summaryStackTitle: `${PREFIX}-summaryStackTitle`,
  summaryStackSubTitle: `${PREFIX}-summaryStackSubTitle`,
  summaryStackText: `${PREFIX}-summaryStackText`,
  summaryRenderDiv: `${PREFIX}-summaryRenderDiv`,
  summaryCustomBox: `${PREFIX}-summaryCustomBox`,
  circularProgress: `${PREFIX}-circularProgress`,
  summaryHeaderCustomBox: `${PREFIX}-summaryHeaderCustomBox`,
  summaryCommStack: `${PREFIX}-summaryCommStack`,
  summaryLinearProgressBox: `${PREFIX}-summaryLinearProgressBox`,
  summaryLinearProgressBox2: `${PREFIX}-summaryLinearProgressBox2`,
  summaryLinearProgressBox3: `${PREFIX}-summaryLinearProgressBox3`,
  summaryCommMainStack: `${PREFIX}-summaryCommMainStack`,
  summaryDataBox: `${PREFIX}-summaryDataBox`,
  summaryMargin: `${PREFIX}-summaryMargin`,
  summaryTexts: `${PREFIX}-summaryTexts`,
  summaryPadding: `${PREFIX}-summaryPadding`,
  summaryDataMargin: `${PREFIX}-summaryDataMargin`,
  rangeLabel: `${PREFIX}-rangeLabel`,
  radioLabel: `${PREFIX}-radioLabel`,
  wide: `${PREFIX}-wide`,
  wide1: `${PREFIX}-wide1`
}

export const Root = styled('div')(({theme}) => ({
  [`& .${classes.root}`]: {
    display: 'flex'
  },

  [`& .${classes.drawer}`]: {
    width: SUMMARY_DRAWER_WIDTH,
    flexShrink: 0
  },

  [`& .${classes.drawerPaper}`]: {
    width: SUMMARY_DRAWER_WIDTH,
    marginRight: 8,
    marginTop: 50,
    padding: 12,
    height: '100vh',
    overflowX: 'hidden',
    borderRadius: 4,
    boxShadow: theme.shadows[4]
  },

  [`& .${classes.mainFiltersContainer}`]: {
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center'
  },

  [`& .${classes.title}`]: {
    marginBottom: theme.spacing(2)
  },

  [`& .${classes.summarySubsectionContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  [`& .${classes.summaryTitle}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.h6.fontSize,
    color: theme.palette.hpAccentBlack
  },
  [`& .${classes.summarySubtitle}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.listItemMedium?.fontSize,
    color: theme.palette.hpBaseDark,
    lineHeight: theme.typography.overline?.lineHeight
  },
  [`& .${classes.summarySubtitle2}`]: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.hpBaseDark
  },

  [`& .${classes.summaryParagraph}`]: {
    fontWeight: theme.typography.body2,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.hpAccentBlack
  },

  [`& .${classes.summaryStackTitle}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.bodyLarge?.fontSize,
    height: 25,
    color: theme.palette.hpPrimaryDark
  },
  [`& .${classes.summaryStackSubTitle}`]: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.subtitleMedium?.fontSize,
    height: 17,
    color: theme.palette.hpPrimaryDark
  },

  [`& .${classes.summaryStackText}`]: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.hpBaseDark,
    marginTop: 5,
    marginBottom: 6,
    textAlign: 'center'
  },

  [`& .${classes.summaryTitleColorTeal}`]: {
    color: theme.palette.hpAccentTeal
  },

  [`& .${classes.summaryCustomBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '-0.5'
  },
  [`& .${classes.summaryDataBox}`]: {
    paddingRight: 1,
    marginTop: 10
  },
  [`& .${classes.summaryHeaderCustomBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  [`& .${classes.summaryCommStack}`]: {
    alignItems: 'center',
    direction: 'column',
    flexWrap: 'wrap'
  },
  [`& .${classes.wide}`]: {
    textAlign: 'center',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '31%'
  },
  [`& .${classes.wide1}`]: {
    minWidth: '33.3333%'
  },
  [`& .${classes.summaryCommMainStack}`]: {
    paddingTop: 10,
    paddingBottom: 10,
    alignItems: 'center',
    direction: 'row',
    justifyContent: 'space-evenly'
  },
  [`& .${classes.summaryTexts}`]: {
    alignItems: 'center',
    direction: 'row',
    justifyContent: 'space-evenly',
    marginTop: 5
  },
  [`& .${classes.summaryLinearProgressBox}`]: {
    display: 'flex',
    alignItems: 'center'
  },
  [`& .${classes.summaryLinearProgressBox2}`]: {
    width: '100%',
    marginRight: 10,
    marginTop: -1
  },
  [`& .${classes.summaryLinearProgressBox3}`]: {
    minWidth: 35,
    color: 'text.secondary',
    marginTop: -2
  },
  [`& .${classes.circularProgress}`]: {
    alignSelf: 'center',
    mb: 0.5
  },
  [`& .${classes.summaryPadding}`]: {
    padding: 1
  },
  [`& .${classes.summaryMargin}`]: {
    marginTop: -1.2
  },

  [`& .${classes.closeButton}`]: {
    padding: 0
  }
}))

export const StyledDivider = styled(Divider)(() => ({
  marginTop: '8px',
  marginBottom: '8px'
}))

export const LinearProgressBar = styled(LinearProgress)(({theme}) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.hpBaseLighter,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.hpBaseLighter
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.hpAccentTeal,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.hpAccentTeal
    })
  }
}))

export const StyledNoData = styled(Typography)(({theme}) => ({
  color: theme.palette.hpBaseDark
}))
